import { createAsyncThunk } from "@reduxjs/toolkit";
import { HttpStatusCode } from "axios";
import { ClockifyTimeEntriesResponse } from "./ClockifyTimeEntriesResponse";
import axiosInstance from "../axiosInstance/axiosInstance";
import { ClockifyTimeEntriesReportMapper } from "./ClockifyTimeEntriesReportMapper";
import { ClockifyTimeEntry } from "./ClockifyTimeEntry";

export const fetchClockifyTimeEntriesAsync = createAsyncThunk(
  "clockifyTimeEntries/fetchClockifyTimeEntries",
  async (milestoneId: number, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get<ClockifyTimeEntriesResponse[]>(
        `/clockifytimeentries/${milestoneId}`
      );

      if (response.status !== HttpStatusCode.Ok) {
        throw new Error("Failed to fetch task reports");
      }

      const data = response.data;
      const clockifyTimeEntriesReportMapper =
        new ClockifyTimeEntriesReportMapper();
      const mappedData: ClockifyTimeEntry[] = data.map(
        clockifyTimeEntriesReportMapper.mapClockifyTimeEntriesResponseToClockifyTimeEntry
      );

      return mappedData;
    } catch (error) {
      console.error("Error fetching task reports:", error);
      throw error;
    }
  }
);
